import { FC } from 'react';
import { ic_warning } from '.';

const WarningIcon: FC<{ width?: number }> = ({ width = 48 }) => {
  return <img src={ic_warning} width={width} alt="" />;
};

export default WarningIcon;
